import type {
  GetDocumentsExternalFilesDownloadRequestType,
  GetDocumentsExternalFilesDownloadResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

/**
 * Method to get rendered external file url
 *
 * @param params - Parameters for fetching rendered external files url
 */
export const getDocumentExternalFilesDownload = async (
  params: GetDocumentsExternalFilesDownloadRequestType,
) => {
  const url = `/api/v2/documents/${params.documentId}/external-files/${params.externalFileId}/download`;
  const { headers } =
    await apiAuthClient.get<GetDocumentsExternalFilesDownloadResponseType>(
      url,
      {
        headers: {
          accept: '/',
        },
        ...params,
      },
    );

  return headers['x-redirect-to'];
};
